@if (kirjanpitajaOnDevaajaObservable | async) {
  <div style="padding-bottom: 20px; padding-left: 1em; padding-right: 1em; padding-top: 1em">
    <h3 style="margin: 0">Urit</h3>
    <div>
      Päätilikartta: <a [href]="paatilikarttaEncodedUriObservable | async" target="_BLANK">{{ paatilikarttaUriObservable | async }}</a>
    </div>
    <div>
      Asiakkaan tilikartta: <a [href]="asiakkaanTilikarttaEncodedUriObservable | async" target="_BLANK">{{ asiakkaanTilikarttaUriObservable | async }}</a>
    </div>
  </div>
}

<div style="display: flex; justify-content: space-between; flex-flow: row; align-items: center; margin-bottom: 10px">
  <div style="width: 75px">
    <mat-select placeholder="Kieli" [formField]="kieli" (selectionChange)="kieliMuuttui($event)" style="width: 100%">
      <mat-option value="fi">Suomi</mat-option>
      <mat-option value="en">Englanti</mat-option>
    </mat-select>
  </div>
  <div style="width: 150px">
    <mat-select placeholder="Tilikartta" [formField]="profiili" (selectionChange)="profiiliMuuttui($event)" style="width: 100%">
      <mat-option [value]="'maksuperusteinen'">Kevyt</mat-option>
      <mat-option [value]="'liikekirjuri'">Liikekirjuri</mat-option>
    </mat-select>
  </div>
  <app-primary-button (click)="lisaa()" actionId="Avasi dialogin: Lisää tili asiakkaan tilikarttaan" additionalClass="mat-elevation-z4" styles="padding-left: 8px;" matIcon="add"> Lisää tili </app-primary-button>
</div>

@if (commonError()) {
  <div class="error-text">{{ commonError() }}</div>
}

@if (loading()) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<div class="example-list" [class.hidden]="loading()" cdkDropList (cdkDropListDropped)="drop($event)">
  @for (node of flatatyt | async; track node) {
    <div [class.draggable]="node.kirjanpitotili.numero.length > 4" [class.dark-gray-text]="5 > node.kirjanpitotili.numero.length" [class.notdraggable]="5 > node.kirjanpitotili.numero.length" class="example-box" (click)="muokkaa(node.kirjanpitotili)" [style.padding-left]="node.level * 15 + 'px'" cdkDrag>
      {{ node.name }}
      @if (5 > node.kirjanpitotili.numero.length) {
        <div>
          <div *cdkDragPreview class="red-text" style="border: 1px solid red">Päätilikartan tilejä EI voi järjestellä.</div>
        </div>
      }
    </div>
  }
</div>
